/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react";
import Card from "../components/ui/card";
import Content from "../components/ui/content";
import HomeForm from "../components/home/home-form";

import DocumentationContext from "../store/documentation-context";

const HomePage = () => {
  const documentationCtx = useContext(DocumentationContext);

  useEffect(() => {
    documentationCtx.updateForm(undefined, undefined, undefined);
    documentationCtx.updateArchivos([]);
  }, []);

  return (
    <Card>
      <Content>
        <HomeForm />
      </Content>
    </Card>
  );
};

export default HomePage;
